export default "__VITE_ASSET__v8C6Yinc__"